import { CircularProgress, SxProps, Theme } from "@mui/material";
import Button from "@mui/material/Button";
import { buttonStyle } from "src/styles/buttonstyle";
import { backgroundColor } from "src/styles/mainstyle";

type SecondaryButtonProps = {
  isLoading?: boolean;
  onClick?: () => void;
  sx?: SxProps<Theme>;
  text: string;
};

export default function SecondaryButton({
  isLoading,
  onClick,
  sx,
  text,
}: SecondaryButtonProps) {
  return (
    <Button
      variant="contained"
      color="primary"
      onClick={onClick}
      sx={{
        alignSelf: "center",
        borderRadius: "20px",
        ...buttonStyle,
        color: backgroundColor,
        backgroundColor: "light-blue", //"white",
        "&:hover": {
          backgroundColor: "white",
        },
        ...sx,
      }}
    >
      {isLoading ? <CircularProgress size={24} color="inherit" /> : text}
    </Button>
  );
}
